import WatchedCampaign from './watched-campaigns';

export default WatchedCampaign;
